import { render, staticRenderFns } from "./Cakes.vue?vue&type=template&id=2aa22cbf&scoped=true"
import script from "./Cakes.vue?vue&type=script&lang=js"
export * from "./Cakes.vue?vue&type=script&lang=js"
import style0 from "./Cakes.vue?vue&type=style&index=0&id=2aa22cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa22cbf",
  null
  
)

export default component.exports